var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "panel-contanier" },
    [
      _c(
        "el-divider",
        { attrs: { "content-position": "left" } },
        [
          _vm._t("header", function () {
            return [_c("span", [_vm._v(_vm._s(_vm.title))])]
          }),
        ],
        2
      ),
      _c("div", { staticClass: "opt" }, [_vm._t("opt")], 2),
      _c(
        "div",
        { staticClass: "panel-content", style: _vm.panelContentSty },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }